export default {
    // UI
    alt_filters_filter: "LED alternative filter",
    ballast_notice: "Ved valg av HF lysrør, så må det sjekkes kompatibilitet mellom ballast og nytt LED lysrør.",
    ballast_notice_tled_link_text: "LED-lysrør",
    ballast_notice_pl_led_link_text: "LED PL-lyskilder",
    introduction_text: "Trykk på et konvensjonelt produkt for å finne LED-alternativet",

    // LED facets
    tiering: "Produktfamilie",
    ballast_compatibility: "Kompatibilitet med forkoblinger",
    lifetime: "Levetid",
    lumen: "Lumen",
    led_no_recommendations: "Det er ingen LED-alternativer for dette produktet.",

    home_search_for_product: "Søk etter ditt produkt",
    conventional_alternative: "Konvensjonelt alternativ",
    led_alternative: "LED alternativ",
    search_filters_filter: "Filter",
    search_submit: "Søk produkt",
    results: "Resultater",
    selected_product: "Valgt produkt",
    search_input: "Skriv inn (en del av) produktkoden eller beskrivelsen",
    what_type_are_you_looking_for: "Hvilken type produkterstatning ser du etter?",
    recommendations_singular: "Anbefalinger",
    recommendations_plural: "Anbefalinger",
    your_product: "Ditt produkt",
    search_filters_reset: "Tilbakestill filtre",
    results_specify: "Det er mer enn 10 resultater, vennligst spesifiser søket ditt",
    energy_efficient: "Energieffektiv",
    active_filters: "Aktive filtre",
    card_action: "Katalog",
    card_show_more: "Vis mer",
    card_show_less: "Vis mindre",
    card_alternative_fit: "Philips beste alternativ",
    card_perfect_fit: "Philips beste alternativ",
    no_results_found: "Ingen resultater. Prøv et annet søkeord",
    results_no_recommendations: "Sittende fast? Ta kontakt med din lokale kundeansvarlige eller salgsrepresentant for å finne en løsning.",
    search_filter_product_type: "Produkttype",
    lighting_type: "Type lampe",
    ean: "EAN",
    product_code: "Produktkode",
    eoc: "EOC",
    family: "Familie",
    discrete_wattage: "Watt",
    wattage: "Watt",
    brand: "Merke",
    driver_type: "Drivertype",
    number_of_lamps: "Antall lamper",
    length: "Lengde",
    color: "Farge",
    base: "Base",
    local_eoc: "El.nr",
    ignitor: "Tenner",
    height: "Høyde",
    width: "Bredde",
    mounting_hole: "Monteringshull",
    mains_voltage: "Nettspenning",
    thermal_protection: "Termisk beskyttelse",
    delta_temperature: "Delta temperatur",
    energy_efficiency: "Energieffektivitet",
    losses: "Tap",
    lamp_current: "Lampestrøm",
    pf_cap: "PF Cap",
    energy_saving: "Energisparing",

};
